import { memo } from 'react';
import cn from 'classnames';
import { IPublisher } from 'src/interface';
import { ObjectUtils } from 'src/utils';
import { Element, Image, LazyloadImage } from 'src/components';
import styles from './styles.module.scss';

interface IProps {
    publisher?: IPublisher;
    hStyle?: number;
    lazyloadImage?: boolean;
}
export function ContentPublisher({
    publisher = {} as IPublisher,
    hStyle = 16,
    lazyloadImage = true,
}: IProps) {
    if (ObjectUtils.isEmpty(publisher)) {
        return null;
    }

    return (
        <Element
            className={cn(styles['bm-card-source'])}
            aria-label="Tới trang nhà xuất bản"
        >
            {lazyloadImage ? (
                <LazyloadImage
                    src={publisher.logo}
                    alt={publisher.name}
                    width={publisher.width || 1}
                    height={publisher.height || 1}
                    style={{
                        width:
                            (hStyle * (publisher.width || 1)) /
                            (publisher.height || 1),
                        height: hStyle,
                    }}
                    aria-label="Logo nhà xuất bản"
                />
            ) : (
                <Image
                    src={publisher.logo}
                    alt={publisher.name}
                    width={publisher.width || 1}
                    height={publisher.height || 1}
                    style={{
                        width:
                            (hStyle * (publisher.width || 1)) /
                            (publisher.height || 1),
                        height: hStyle,
                    }}
                    aria-label="Logo nhà xuất bản"
                />
            )}

            {publisher.showName && (
                <Element renderAs="span" className={styles['source']}>
                    {publisher.shortName}
                </Element>
            )}
        </Element>
    );
}

export default memo(ContentPublisher);
